import { createAction } from 'redux-actions';
import * as types from '../constants/Package';
import { userDataInitialAction, userDataResetLoaderAction } from './UserData';
import { appUpdateStateAction } from './App';
import { getSectionPageStepFromHash, isHashFirstStep } from '../utilities/section/sectionUtils';
import { actionHandler } from '../utilities/form/formUtils';

// Function to replace the url with the latest hash details as query parameter.
const replaceUrl = (currentHash, windowHash = window.location.hash) =>
  `${windowHash.split('?')[0]}?${currentHash.replace(/\//g, '-')}`;

// Actions
// Initial actions.
export const packageInitial = createAction(types.PACKAGE_INITIAL);
export const packageInitialAction = (payload) => (dispatch, getState) => {
  /* eslint-disable no-restricted-globals */
  // Ensure history is correct.
  const step = dispatch(packageInitial(payload));
  const state = getState();
  const { section: { currentHash } } = state;
  const position = Number(history.state);
  history.replaceState(position, currentHash, replaceUrl(currentHash));
  sessionStorage.setItem('stateLastShown', position);
  /* eslint-enable no-restricted-globals */

  return step;
};

export const packageReceive = createAction(types.PACKAGE_RECEIVE);
export const packageReceiveAction = (payload) => (dispatch, getState) => {
  /* eslint-disable no-restricted-globals */
  // Ensure history is correct.
  const step = dispatch(packageReceive(payload));
  const state = getState();
  const { section: { currentHash, packageData } } = state;
  const position = Number(history.state);

  // Set relevant user data here.
  dispatch(userDataInitialAction(packageData));
  history.replaceState(position, currentHash, replaceUrl(currentHash));
  sessionStorage.setItem('stateLastShown', position);
  /* eslint-enable no-restricted-globals */

  // Check if there are debug options. These should be set in App state.
  const { initialValues: { debugServices, debugErrors } } = packageData;
  if (debugServices) {
    dispatch(appUpdateStateAction({
      debugServices,
    }));
  }
  if (debugErrors) {
    dispatch(appUpdateStateAction({
      debugErrors,
    }));
  }
  return step;
};

export const packageRequest = createAction(types.PACKAGE_REQUEST);
export const packageRequestAction = (payload) => (dispatch) => (
  dispatch(packageRequest(payload))
    .then(() => (
      dispatch(packageReceiveAction())
    ))
);

export const packageUpdate = createAction(types.PACKAGE_UPDATE);
export const packageUpdateAction = (payload) => (dispatch) => (
  dispatch(packageUpdate(payload))
);

// Section actions.
export const nextSection = createAction(types.SECTION_NEXT);
export const nextSectionAction = () => (dispatch, getState) => {
  const { userData } = getState();
  return dispatch(nextSection({
    ...userData,
  }));
};

// Page actions.
export const nextPage = createAction(types.PAGE_NEXT);
export const nextPageAction = () => (dispatch, getState) => {
  const { userData } = getState();
  const page = dispatch(nextPage({
    ...userData,
  }));

  // Check if we need to update next page.
  const state = getState();
  if (state.section.nextSection) {
    dispatch(nextSection({
      ...userData,
    }));
  }

  return page;
};

// Step actions.
export const nextStep = createAction(types.STEP_NEXT);
export const nextStepAction = () => (dispatch, getState) => {
  const { userData } = getState();

  // Stop if any idleAction
  if (window.idleAction) {
    window.idleAction.stop();
  }

  // Always Reset loader.
  dispatch(userDataResetLoaderAction());

  // First do update of next step.
  const step = dispatch(nextStep({
    ...userData,
  }));

  // Check if we need to update next page.
  let state = getState();
  if (state.section.currentPageData.nextPage) {
    dispatch(nextPage({
      ...userData,
    }));
  }

  // Check of we need to update next section.
  state = getState();
  if (state.section.nextSection) {
    dispatch(nextSection({
      ...userData,
    }));
    // Get the updated state hash after new section.
    state = getState();
  }

  /* eslint-disable no-restricted-globals */
  const { currentHash } = state.section;
  const position = Number(history.state) + 1;
  history.pushState(position, currentHash, replaceUrl(currentHash));
  sessionStorage.setItem('stateLastShown', position);
  /* eslint-enable no-restricted-globals */
  return step;
};

export const prevStep = createAction(types.STEP_PREV);
export const prevStepAction = () => (dispatch, getState) => {
  /* eslint-disable no-restricted-globals */
  // Check if we're allowed to perform a previous step. If not we just replace the current history.
  let state = getState();

  // Stop if any idleAction
  if (window.idleAction) {
    window.idleAction.stop();
  }

  if (isHashFirstStep(state.section)) {
    const position = Number(history.state);
    history.replaceState(position, state.section.currentHash,
      replaceUrl(state.section.currentHash));
    sessionStorage.setItem('stateLastShown', position);
    return {};
  }

  const { userData, app: { error, errorData } } = getState();
  if (error) {
    dispatch(appUpdateStateAction({ error: false }));
    dispatch(userDataResetLoaderAction());
    dispatch(packageUpdateAction({ errorData }));
  }
  const step = dispatch(prevStep({
    ...userData,
  }));

  // step.nextSectionData;

  // Find out if the page we go back to is a Loader. We cannot go back to those. So we reset.
  state = getState();
  const { section: { currentHash, packageData, nextSectionData, nextPageData } } = state;
  const hashData = getSectionPageStepFromHash(currentHash, packageData);

  if (nextSectionData && nextSectionData.backButtonConfig) {
    actionHandler(nextSectionData.backButtonConfig.actions, null, null, dispatch, userData);
  }

  if (nextPageData && nextPageData.backButtonConfig) {
    actionHandler(nextPageData.backButtonConfig.actions, null, null, dispatch, userData);
  }

  if (hashData) {
    const { page: { component: { componentName } } } = hashData;
    if (componentName === 'Loader') {
      dispatch(userDataResetLoaderAction());
      return dispatch(packageInitialAction());
    }
  }

  const position = Number(history.state);
  history.replaceState(position, currentHash, replaceUrl(currentHash));
  sessionStorage.setItem('stateLastShown', position);
  /* eslint-enable no-restricted-globals */
  return step;
};

// Element Actions.
export const elementToggler = createAction(types.ELEMENT_TOGGLE);
export const elementTogglerAction = (payload) => (dispatch) => {
  dispatch(elementToggler(payload));
};


// WEBPACK FOOTER //
// ./src/actions/Section.js